import { AxiosPromise } from 'axios';
import API from './base';

export type ComponentsType = {
  id: string;
  name: string;
  price: number | string;
  price_reduction: number | string;
  description: string;
  category_name: string;
  hide_parameter: string;
  is_always_selected: boolean;
};

export type ComponentsFrontendType = {
  id: string;
  name: string;
  price: number;
  priceReduction: number;
  description: string;
  categoryName: string;
  hideParameter: string;
  isAlwaysSelected: boolean;
};

export type ApplicantType = {
  is_driving_school_creation: boolean;
  is_driving_school_buying: boolean;
  is_incorporation_started: boolean;
  is_incorporation_done: boolean;
  is_existing_company_buying: boolean;
  has_diploma: boolean;
  has_cqp: boolean;
  is_an_instructor: boolean;
  is_location_found: boolean;
  is_erp: boolean;
  is_insured: boolean;
  has_equipped_vehicle: boolean;
  is_vehicle_insured: boolean;
  is_agreement_requested: boolean;
  department_name: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
};

class OpenDrivingSchoolApi extends API {
  postNewApplicant = (data) => this.post('/api/web/v1/driving_school_applicants', data);

  getApplicant = (applicantId: string): AxiosPromise<ApplicantType> => this.get(`/api/web/v1/driving_school_applicants/${applicantId}`, {});

  getComponents = (): AxiosPromise<ComponentsType[]> => this.get('/api/web/v1/commercial_proposal_components', {});

  postCommercialProposal = (data) => this.post('/api/web/v1/commercial_proposals', data);
}

export default new OpenDrivingSchoolApi();
